module.exports = __webpack_public_path__ + "img/default-avater-female.ad813ebc.jpg";